import { render, staticRenderFns } from "./profileTabContainer.vue?vue&type=template&id=45609c5f&scoped=true&"
import script from "./profileTabContainer.vue?vue&type=script&lang=ts&"
export * from "./profileTabContainer.vue?vue&type=script&lang=ts&"
import style0 from "./profileTabContainer.vue?vue&type=style&index=0&id=45609c5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45609c5f",
  null
  
)

export default component.exports